import React, {Fragment, useState, useEffect} from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import axios from 'axios';
import ReCAPTCHA from "react-google-recaptcha";
import Swal from 'sweetalert2'
import { Cabecera } from '../components/Cabecera';
import { Footer } from '../components/Footer';




export const Contacto = (props) => {

    const recaptchaRef = React.createRef();
    const [aceptCaptha, setAceptCaptha] = useState(false);
    const onChange = (value) => {
        setAceptCaptha(true)
      }

    const [messageLogin, setmessageLogin] = useState('');
    const messageLoginChange = (val) => {
        setmessageLogin(val)
    }

    const [formIsInvalid, setformIsInvalid] = useState(false);
    const formIsInvalidChange = (val) => {
        setformIsInvalid(val)
    }
    
    const [nombreData, setNombreData] = useState(localStorage.getItem(`${process.env.REACT_APP_ID_STORAGE}-nombre`));
    const nombreChange = (val) => {
        setNombreData(val.target.value)
    }

    const [emailData, setEmailData] = useState(localStorage.getItem(`${process.env.REACT_APP_ID_STORAGE}-email`));
    const emailChange = (val) => {
        setEmailData(val.target.value)
    }

    const [asuntoData, setAsuntoData] = useState(null);
    const asuntoChange = (val) => {
        setAsuntoData(val.target.value)
    }

    const [mensajeData, setMensajeData] = useState(null);
    const mensajeChange = (val) => {
        setMensajeData(val.target.value)
    }

    const sendContacto = async () => {

        try {
            var dataForm = {
                "nombre":nombreData,
                "email": emailData,
                "asunto": asuntoData,
                "mensaje": mensajeData,
            }
            let axiosConfig = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                  },  
              };
            console.log('go to axios')
            await axios.post(`${process.env.REACT_APP_URL_API}formatos/EnviarFormularioContacto`, dataForm, axiosConfig)
            .then(resLogin => {
                console.log('resLogin',resLogin.data)
                if(resLogin.status === 200){
                    if(resLogin.data === 'error'){
                        console.log('err2')
                        messageLoginChange('El formulario contiene errores')
                    }else{
                        formIsInvalidChange(false)
                          Swal.fire({
                            title: '',
                            text: `Mensaje enviado`,
                            icon: 'success',
                            showCancelButton: false,
                            confirmButtonColor: '#42A72C',
                            cancelButtonColor: '#E5324B', 
                            confirmButtonText: 'Aceptar',
                            cancelButtonText: 'Cancelar'
                         }).then((result) => {
                            if(result.value){
                                
                           }
                         })
                   
                    }
                }else{
                    console.log('err')
                    messageLoginChange('El formulario contiene errores')
                }

            })
              
        } catch (error) {
            //setloaddata(false);
            console.log(error)
            messageLoginChange('El formulario contiene errores') 
            formIsInvalidChange(true)
        }
    }

    return(
        <Fragment>
            <Cabecera imagen={true} top={false} removeAuth={props.removeAuth} subtitulo='En UPTA Andalucía estamos<br/> a tu disposición' titulo='¡AUTÓNOM@!' urlimagen="banner_contacto.png" />
            <div id="formcontacto" className="container top-30">
                <div className="row">
                     <div className="col-lg-12">
                     ¿Tienes preguntas o necesitas ayuda? Escríbenos, te asesoramos en todo lo que necesites.<br/>
                     Si tienes alguna incidencia técnica o problemas para acceder al contenido, escríbenos a: <a href="mailto:info@laneurona.com" target="_blank">info@laneurona.com</a>
                     </div>
                </div>
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                       
                        <form className="form form-contacto" onSubmit={(e) =>{ e.preventDefault(); sendContacto()}}>
                            <div class="row">
                                <div class="col">
                                    <div className="form-group mb-2 mr-sm-2">
                                        <input className={formIsInvalid ? 'form-control is-invalid' : 'form-control'}  type="text" id="nombre" name="nombre" placeholder="Nombre*" required value={localStorage.getItem(`${process.env.REACT_APP_ID_STORAGE}-nombre`)}  onChange={ nombreChange } /><br/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div className="form-group mb-2 mr-sm-2">
                                        <input className={formIsInvalid ? 'form-control is-invalid' : 'form-control'}  type="email" id="email" name="email" placeholder="Email*" required value={localStorage.getItem(`${process.env.REACT_APP_ID_STORAGE}-email`)}  onChange={ emailChange } /><br/>
                                    </div>
                                </div>
                             </div>
                            <div class="row">
                                <div class="col">
                                    <div className="form-group mb-2 mr-sm-2">
                                        <input className={formIsInvalid ? 'form-control is-invalid' : 'form-control'}  type="text" id="asunto" name="asunto" placeholder="Asunto"   onChange={ asuntoChange } /><br/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div className="form-group mb-2 mr-sm-2">
                                        <textarea className={formIsInvalid ? 'form-control is-invalid' : 'form-control'} id="mensaje" name="mensaje" rows="3" placeholder="Mensaje*"  required  onChange={ mensajeChange }></textarea>
                                    </div>
                                </div>
                            </div>
                            <ReCAPTCHA
                                                ref={recaptchaRef}
                                                sitekey="6Lfso_4ZAAAAACvxcgENu4ZlutKf3CfJy1z7pkrh"
                                                onChange={onChange}
                                            />
                            <hr/>
                            <p className="form-text text-muted">*campos obligatorios</p>
                            <div class="row">
                                <div class="col col-lg-4">
                                
                                    <div className="form-group">
                                        <button className="btn btn-primary btn-form" type="submit" disabled={!aceptCaptha}  >Enviar</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>	
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <hr/>
                        <p className="info-contacto">
                        La comunicación enviada quedará incorporada a un fichero del que es responsable UNION DE PROFESIONALES Y TRABAJADORES AUTÓNOMOS DE ANDALUCÍA. Esta comunicación se ‘utilizará exclusivamente para tratar sus datos para atender su solicitud, siempre de acuerdo al Reglamento (UE) 2016/679 (RGPD), la Ley Orgánica15/1999 (LOPD) y el Real Decreto 1720/2007 de desarrollo de la LOPD), sobre protección de datos. Sus datos no se comunicaran a terceros, excepto por obligación legal, y se mantendrán mientras no solicite su cancelación.En cualquier momento usted puede ejercer los derechos de acceso, rectificación, portabilidad y oposición, o si procede, a la limitación y/o cancelación del tratamiento, comunicándolo por escrito, indicando sus datos personales a Avenida Blas Infante, 4, 4a planta y media 41011, sevilla o mediante un email a info@upta- andalucia.org.
                        </p>
                    </div>
                </div>			
            </div>
            <Footer />
        </Fragment>
    )

}